import { Row, Col, Typography } from "antd";
const { Text, Link } = Typography;

export default function MaintenanceWarningBanner() {
  return (
    <Row className="info-banner block text-lg px-4 py-2">
      <Col>
        <Text>
          Biobot&rsquo;s Sample Log submission form will be unavailable for a
          brief time starting Tuesday, September 15th at 5:00 PM ET (2:00 PM PT)
          to perform scheduled maintenance. We anticipate this down time to be
          up to 1-2 hours, and you will see an improved sample log form
          afterwards. To avoid processing delays, please ensure any samples
          collected that day are submitted before this down time or you can fill
          out the included paper log. Please feel free to reach out to us at{" "}
          <Link href="mailto:support@biobot.io">support@biobot.io</Link> for any
          assistance.
        </Text>
      </Col>
    </Row>
  );
}
